<template>
  <div class="enter-school-form-batch-download"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="main-cont">
      <div class="batch-select">
        <span class="custom-label">报名批次</span>
        <el-select v-model="batchId"
                   size="mini"
                   filterable
                   placeholder="请选择报名批次">
          <el-option v-for="batch in batchList"
                     :key="batch.id"
                     :label="batch.name"
                     :value="batch.id"></el-option>
        </el-select>
      </div>
      <AsyncTaskModule ref="asyncTaskModule"
                       action-url="/workspace/manager/enrolling/query/downloadEnterSchoolFormBatch"
                       confirm-msg="按报名教学点分组生成压缩包，每个教学点为一个子压缩包。"
                       complete-message="入学登记表压缩包生成完成"
                       :extra-params="taskParams"
                       :pre-handle-verify="verifyBatchSelected"
                       @onClose="handleClose">
      </AsyncTaskModule>
    </div>
  </div>
</template>

<script>
import AsyncTaskModule from '../../../../../../elements/AsyncTaskModule'

export default {
  name: 'EnterSchoolFormBatchDownload',
  components: {
    AsyncTaskModule
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      batchId: '',
      batchList: []
    }
  },
  computed: {
    taskParams () {
      return {
        batchId: this.batchId
      }
    }
  },
  methods: {
    loadBatchList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/query/enterSchoolFormBatchOptions',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data.responseCode) {
            case 'SUCCESS': {
              this.batchList = response.data.batchOptions || response.data.options || []
              this.batchId = ''
              break
            }
            default: {
              this.batchList = []
              this.batchId = ''
              this.$message.warning(response.data.message || '获取报名批次失败')
              break
            }
          }
        }
      }, () => {
        this.batchList = []
        this.batchId = ''
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    verifyBatchSelected () {
      if (!this.batchId) {
        this.$message.warning('请选择报名批次后再下载')
        return false
      }
      return true
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadBatchList()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadBatchList()
      }
    }
  }
}
</script>

<style lang="scss">
.enter-school-form-batch-download {
  background-color: #fff;
  & > .main-cont {
    padding: 15px;
    .batch-select {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
        color: #606266;
      }
      .el-select {
        width: 280px;
      }
    }
  }
}
</style>
